module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/pUdOiO/tc-custom/9781398471009.jpg?1705540293305",
      "alt": "This image is the cover for the book Alliance"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Alliance\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("What happens when humans discover that they are not alone in the vastness of the Universe? Theodore Newsome’s space cadet training is abruptly cut short not far from completion. That is one of the first consequences. He is thrown in at the deep end along with three of his fellow space cadets. It is a deep end that could be bottomless. Contact with aliens was not meant to be like this, especially as a threat to an alien race could soon become a threat to the human race.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Graham E Howarth\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Graham E Howarth is a retired primary school head teacher who lives in Bury, Lancashire. He is married to Helen and has two daughters, Sarah and Kate. Alliance is the first novel in his Far Future trilogy that moves on to Containment and then Infinity. He has also written his autobiography, If Only I’d Asked, plus The Burrs Country Park, Bury, a record in poems and pictures, including a brief history of the park. Both have been self-published for local sale. A History of The Burrs, Bury will also be published locally in 2022. He has been a science fiction aficionado for many years.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0